import { render, staticRenderFns } from "./CategoryLoading.vue?vue&type=template&id=4a5f8ab7&"
import script from "./CategoryLoading.vue?vue&type=script&lang=js&"
export * from "./CategoryLoading.vue?vue&type=script&lang=js&"
import style0 from "./CategoryLoading.vue?vue&type=style&index=0&id=4a5f8ab7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports